<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import ThuxGenericComponentFilterMixin from '../../../components/thux-list/ThuxGenericComponentFilterMixin'
import { CommonFilterTypes } from '../store'

export default {
  name: 'OwnerContactListFilter',
  mixins: [ThuxGenericComponentFilterMixin],
  data () {
    return {
      icon: 'far fa-user',
      itemName: 'referent',
      itemPluralName: 'referents',
      placeholder: 'Type a contact person',
      filterName: 'filter__last_name__icontains',
      searchLength: 3
    }
  },
  computed: {
    ...mapGetters({
      list: CommonFilterTypes.COMMON_FILTERS.OWNER_CONTACT_COMMON_FILTER.LIST.GETTERS.list
    }),
    listOptions () {
      const options = []
      const list = this.list && this.list.results ? this.list.results : this.list
      if (list && list.length > 0) {
        list.forEach((contact) => {
          options.push({
            id: contact.id,
            name: `${contact.last_name} ${contact.first_name}`
          })
        })
      }
      return options
    }
  },
  methods: {
    ...mapMutations({
      setList:
        CommonFilterTypes.COMMON_FILTERS.OWNER_CONTACT_COMMON_FILTER.LIST.MUTATIONS.setList
    }),
    ...mapActions({
      ...CommonFilterTypes.COMMON_FILTERS.OWNER_CONTACT_COMMON_FILTER.LIST.ACTIONS
    }),
    getComponentFilter () {
      this.setList({})
    }
  }
}
</script>
